/**
 * Skeleton Component
 */

import { cn } from '@tonnie/foundation';

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  // `data-slot` names the placeholder, so "this region is still loading" is
  // observable (the E2E sweeps wait for a region to hold none).
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
